<template>
  <div>
    <div v-if="!fetched">
      <vue-default-svg-loader></vue-default-svg-loader>
    </div>
    <div v-else-if="fetched && clientSocialLinks.length > 0">
      <display-data
        v-for="(link, index) in clientSocialLinks"
        :key="index"
        :display-data="link"
        :display-title="link.link_of"
        :display-value="link.link"
        :edit-form.sync="clientSocialLinkForm"
        :edit-data.sync="selectedClientSocialLinkData"
        link
        editable
        class="hover-grey"
      ></display-data>
    </div>
    <div v-else>
      <vue-no-data :text="`Client social links not found.`"></vue-no-data>
    </div>
    <div>
      <!-- Client Social Link Form -->
      <v-bottom-sheet v-model="clientSocialLinkForm" persistent>
        <v-card tile>
          <vue-card-title
            :title="cardTitle"
            :subtitle="
              'Fill up the following form to action on client social links.'
            "
            closable
            :icon="$getIcon('mdiFileDocumentEdit')"
            @close="clientSocialLinkForm = false"
          >
          </vue-card-title>
          <v-divider></v-divider>
          <v-card-text class="form-scroll">
            <client-social-link-form
              v-if="selectedClientSocialLinkData && clientSocialLinkForm"
              :action-data="selectedClientSocialLinkData"
              @clientSocialLinkFormResponse="formSuccess"
              :client-slug="clientSlug"
            >
            </client-social-link-form>
          </v-card-text>
        </v-card>
      </v-bottom-sheet>
      <!-- / Client Social Link Form -->
    </div>
  </div>
</template>

<script>
import DisplayData from "@/components/crm/layout_utils/DisplayData";
import ClientSocialLinkForm from "@/components/crm/client/forms/ClientSocialLinkForm";

export default {
  components: { ClientSocialLinkForm, DisplayData },
  props: {
    clientSocialLinkForm: {
      type: Boolean,
      default: false
    },
    clientSlug: {
      type: String,
      required: false,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      fetched: false,
      clientSocialLinks: [],
      // form
      selectedClientSocialLinkData: {},
      cardTitle: ""
    };
  },
  watch: {
    clientSocialLinkForm(newVal) {
      this.$emit("update:socialLinkForm", newVal);
      if (Object.keys(this.selectedClientSocialLinkData).length > 0 && newVal) {
        this.cardTitle = "Update Client Social Link";
      } else {
        this.selectedClientSocialLinkData = {};
        this.cardTitle = "Create Client Social Link";
      }
    },
    clientSlug() {
      this.fetchClientSocialLinks();
    }
  },
  methods: {
    fetchClientSocialLinks() {
      const clientSocialLinkAPI = "/api/v1/crm/client-social-link/";
      this.fetched = false;
      const params = {
        client__slug: this.clientSlug
      };
      this.$axios.$get(clientSocialLinkAPI, { params }).then(response => {
        this.clientSocialLinks = response.results;
        this.fetched = true;
      });
    },
    formSuccess() {
      this.clientSocialLinkForm = false;
      this.fetchClientSocialLinks();
    }
  }
};
</script>
